// Design System - Spacing Scale
// Inspired by React Native GridSystem approach

export const spacing = {
    tiny: '4px',
    small: '8px',
    medium: '16px',
    mediumLarge: '24px',
    large: '32px',
    xlarge: '48px',
    xxlarge: '64px'
};

// Responsive spacing helpers
export const getSpacing = (size) => spacing[size] || spacing.medium;
